@if ({
  counterResultRequest: counterResultRequest$ | async,
  }; as content) {
  <div class="container-plp-counter">
    @if (!content.counterResultRequest?.isLoading) {
      @if (!content.counterResultRequest?.hasError) {
        @if (content.counterResultRequest?.results?.length) {
          <ul>
            @for (item of content.counterResultRequest?.results; track item) {
              <li>
                <a [routerLink]="[item.path, currentTerm]" class="btn {{ item.class }}" [ngClass]="{ disabled: item.disabled }">
                  ({{ item.qty }}) {{ item.label }}
                </a>
              </li>
            }
          </ul>
        }
      } @else {
        <alert [alert]="errorMessage"></alert>
      }
    } @else {
      <local-loader></local-loader>
    }
  </div>
}
